import { EntityKeyByReference } from '@card-software/library';
import { EntityKey } from '../../inventory/keys/entity-key';
import { Business } from '../../finance/business';

export enum PurchaseOrderStatus {
  Draft,
  Submitted,
  Approved,
  Receiving,
  PartiallyReceived,
  Received,
  Rejected,
  Cancelled,
}

export enum PurchaseOrderType {
  Standard,
  Yarn,
  Chemicals,
  /** Confidential purchasing (#5942): role-gated, Services items only, follows the Standard receiving path. */
  Administrative,
}

export interface PurchaseOrderItemEntry {
  itemCode: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  tax?: number;
  notes?: string;
  owner?: EntityKey;
}

export interface PurchaseOrderItem extends PurchaseOrderItemEntry {
  id: string;
  itemDescription?: string;
  uom?: number;
  unitOfMeasure?: string;
  totalPrice: number;
}

export interface PurchaseOrderEntry {
  purchaseOrderNumber?: string;
  providerReference: string;
  billToReference: string;
  shipToReference: string;
  status: PurchaseOrderStatus;
  orderDate: Date;
  expectedDeliveryDate?: Date;
  items: PurchaseOrderItemEntry[];
  notes?: string;
  relatedEntities?: EntityKeyByReference[];
}

export interface PurchaseOrder extends Omit<PurchaseOrderEntry, 'items'> {
  id: string;
  items: PurchaseOrderItem[];
  purchaseOrderReference?: string;
  customerOrderNumber?: string;
  shipmentsReferences?: string[];
  invoiceReferences?: string[];
  totalAmount?: number;
  createdBy?: string;
  modifiedBy?: string;
  createdDate?: string;
  modifiedDate?: string;
  providerName?: string;
  billToName?: string;
  shipToName?: string;
  provider?: Business;
  shipTo?: Business;
  billTo?: Business;
  currency?: Currency;
  type?: PurchaseOrderType;
  destinationLocationCodes?: string[];
  destinationLocationNames?: { en?: string; es?: string }[];
  goodsReceiptNumbers?: string[];
}

export enum Currency {
  USD,
  HNL,
  EUR,
}

export interface PurchaseOrderStatusCommand {
  newStatus: PurchaseOrderStatus;
}

export interface PurchaseOrderSearch {
  purchaseOrderNumber?: string;
  providerReference?: string;
  billToReference?: string;
  shipToReference?: string;
  itemCodes?: string[];
  relatedEntities?: EntityKeyByReference[];
  status?: PurchaseOrderStatus[];
  type?: PurchaseOrderType;
  /** Any of these types (#5946); OR-ed with `type` by the API. */
  types?: PurchaseOrderType[];
  destinationLocationCodes?: string[];
}
